import React from 'react';

import Loader from '../../assets/components/loader';

const CustomModal = ({
  children,
  header = true,
  body = true,
  footer = true,
  isForm = true,
  twoColumnForm = false,
  modalTitle = 'Modal Title',
  changeModalState,
  onSave,
  loading,
  submitButtonLabel = "Save",
  disableSubmitButton = false,
  cancelButton = true,
  cancelButtonLabel = "Cancel",
  background = "",
  width = "",
  height = "",
  centerFooter = false
}) => {

  const handleClick = (event) => {
    if (event.target.classList.contains('custom--modal')) {
      changeModalState();
    }
  };

  return (
    <div className='custom--modal' onClick={ev => handleClick(ev)}>
      <div className='modal--structure' style={{ background: background, width: width, height: height }}>
        {(header && <div className='modal--header'>
          <div className='modal--title'>
            <h2>{modalTitle}</h2>
          </div>
          <div onClick={ev => changeModalState()}>
            &times;
          </div>
        </div>)}
        {(isForm &&
          <form onSubmit={ev => onSave(ev)}>
            {(body &&
              <div
                //style={!footer ? { height: "100%" } : ""}
                className={twoColumnForm ? 'modal--body marquet--form two--columns--form border--top' : 'modal--body marquet--form border--top'}>
                {children}
              </div>
            )}
            {(footer &&
              <div className={centerFooter ? 'modal--footer border--top footer--centered' : 'modal--footer border--top'}>
                <button
                  type='submit'
                  className='custom--button custom--button--marquet'
                  disabled={loading?true:false}
                  disabled={disableSubmitButton}>
                  {submitButtonLabel} {loading && <Loader size="xs"/>}
                </button>
                {cancelButton &&
                  <button type='button' className='custom--button custom--button--marquet'
                    onClick={ev => changeModalState()}>
                    {cancelButtonLabel}
                  </button>
                }
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  )
}

export { CustomModal };